






import { Vue, Component, Prop } from 'vue-property-decorator';
import { HANDLE_AUTHENTICATION } from '@/store';

@Component
export default class Callback extends Vue {
  created() {
    return this.$store
      .dispatch(HANDLE_AUTHENTICATION)
      .then((data: any) => {
        this.$router.push(data.appState);
      })
      .catch((err: any) => console.log(err))
      .finally();
  }
}
